import BaseComponent from '../../../../base/base_component';
import Model from './stripe_component_model';
import DOM from '../../../../utils/dom';
import Directive from '../../../../core/directive';

import _ from '../../../../utils/underscore';
let stripeHTML = require('./view/stripe.html'),
    sessionHTML = require('./view/session-id.html');

class StripeComponent extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ComponentClassName';


    /**
     * Root component selector.
     *
     * @type {string}
     */
    _selector = 'cgp-stripe-component';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;


    /**
     *
     * @param params
     */
    init(params) {
        super.init();
        this._model = Model.create(params);
        if (params && !_.isEmpty(params.innerHtml)) {
            stripeHTML = params.innerHtml;
        }
    }


    /**
     * Start the component view.
     *
     *
     * @returns {*}
     * @public
     */
    start() {
        let bakedStripeHTML = this.bake(stripeHTML, {});
        this
            .setHTML(bakedStripeHTML)
            ._onClock();

        return this;
    }

    closeFnc(closeCallback) {
        this._onCloseCallbacks = closeCallback;
    }
    /**
     *
     * @private
     */
    _onClock() {
        if (!this._model.getShowClock()) {
            this.logger.debug('Clock is set by configuration to be not display.');
            return this;
        }

        this._clock = Directive.generate({directiveName: 'clock', start: true, props: {datetime: this.serviceFactory.skinService().getTimeFormat()}});

        if (!this._clock) {
            this.logger.error('Clock component not created!');
            return this;
        }

        // Append the clock into the navbar DOM.
        DOM.append(this.getEl().querySelector('.cgp-stripe-clock'), this._clock.getEl());

        return this;
    }


    /**
     *
     * @param sessionID
     * @returns {NavBarComponentController}
     */
    setStripeSessionID(sessionID) {
        if (_.isUndefined(sessionID)) {
            this.logger.debug('Getting undefined session id');
            return this;
        }

        let bakedSessionHTML = this.bake(sessionHTML, {sessionID: sessionID});

        // Append the session into the navbar DOM.
        DOM.html(bakedSessionHTML, this.getEl().querySelector('.cgp-stripe-game-session'));
        return this;
    }
}

export default StripeComponent;